import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  MoveProposalGroupOrLineItemInput,
  MoveProposalGroupOrLineItemMutation,
} from '@/gql/graphql';

const MOVE_PROPOSAL_GROUP_OR_LINE_ITEM_MUTATION = graphql(`
  mutation MoveProposalGroupOrLineItem(
    $input: MoveProposalGroupOrLineItemInput!
  ) {
    moveProposalGroupOrLineItem(input: $input) {
      id
    }
  }
`);

const useMoveProposalGroupOrLineItem = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    MoveProposalGroupOrLineItemMutation,
    unknown,
    MoveProposalGroupOrLineItemInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: MoveProposalGroupOrLineItemInput) => {
      return gqlClient.request(MOVE_PROPOSAL_GROUP_OR_LINE_ITEM_MUTATION, {
        input,
      });
    },
    scope: args?.proposalId
      ? { id: proposalMutationScopeId(args.proposalId) }
      : undefined,
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useMoveProposalGroupOrLineItem;
